import React from "react";
import { Container, Card } from "react-bootstrap";

export const AccessDenied = () => (
  <Container className=" task">
    <Card className="create-task">
      <Card.Header>
        <h3>Sorry, you are unauthorized to view this page...</h3>
        <br />
        If you think this is a mistake, please get in touch with a site administrator.
      </Card.Header>
    </Card>
  </Container>
);
